import { render, staticRenderFns } from "./AssetEditor.vue?vue&type=template&id=9891b81a&"
import script from "./AssetEditor.vue?vue&type=script&lang=js&"
export * from "./AssetEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports